import { render } from "./Hamburger.vue?vue&type=template&id=888c0740"
const script = {}
script.render = render

export default script